import { getStorageValue, removeStorageValue, setStorageValue } from "@/storage"

const STORAGE_KEY = "refreshToken"

export const getRefreshToken = () => getStorageValue<string>(STORAGE_KEY)

export const setRefreshToken = (value: string) => {
  setStorageValue(STORAGE_KEY, value)
}

export const removeRefreshToken = () => {
  removeStorageValue(STORAGE_KEY)
}
